import Vue from 'vue'
import Router from 'vue-router'

const index = (resolve) => {
  import('../views/index/index').then((module) => {
    resolve(module)
  })
};
const buy = (resolve) => {
  import('../views/buy').then((module) => {
    resolve(module)
  })
};
const comments = (resolve) => {
  import('../views/comments').then((module) => {
    resolve(module)
  })
};
const contact = (resolve) => {
  import('../views/contact').then((module) => {
    resolve(module)
  })
};
const user = (resolve) => {
  import('../views/info/user').then((module) => {
    resolve(module)
  })
};
const ipInfo = (resolve) => {
  import('../views/info/ipInfo').then((module) => {
    resolve(module)
  })
};
Vue.use(Router);

const router = new Router({
  // mode: 'history',
  routes: [{
      path: '/',
      component: index,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/home',
      component: index,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/buy',
      component: buy,
      meta: {
        title: '购买'
      }
    },
    {
      path: '/comments',
      component: comments,
      meta: {
        title: '用户评论'
      }
    },
    {
      path: '/contact',
      component: contact,
      meta: {
        title: '联系我们'
      }
    },
    {
      path: '/user',
      component: user,
      meta: {
        title: '个人详情'
      }
    },{
      path: '/ipInfo',
      component: ipInfo,
      meta: {
        title: 'ip信息'
      }
    },
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js